import React from 'react';
import { QuestionCard } from './QuestionCard';
import { LoadMoreButton } from './LoadMoreButton';
import { Question } from '../../types/qa';

interface QuestionListProps {
  questions: Question[];
  onVote: (id: string) => void;
}

const PREVIEW_COUNT = 12;

export function QuestionList({ questions, onVote }: QuestionListProps) {
  const previewQuestions = questions.slice(0, PREVIEW_COUNT);
  const hasQuestions = questions.length > 0;

  return (
    <div>
      {hasQuestions ? (
        <>
          <div className="space-y-4">
            {previewQuestions.map((question) => (
              <QuestionCard
                key={question.id}
                question={question}
                onVote={onVote}
              />
            ))}
          </div>
          <LoadMoreButton />
        </>
      ) : (
        <div className="text-center py-12">
          <p className="text-gray-600 dark:text-gray-400">No questions found for this category.</p>
        </div>
      )}
    </div>
  );
}